import { useHistory, useRouteMatch } from 'react-router';
import { FormData, IForumService } from '../model/interfaces';
import { container } from 'tsyringe';
import { ReactComponent as UndoIcon } from '@ui-kit/icons/undo.svg';
import styles from '../styles/topicsList.module.scss';
import { ResponseCode } from '@base/utils/constants';
import { forumId } from '../constants/forumId';
import FormWithEditor from './formWithEditor';
import { IMessage } from '@base/features/message/message';
import { useState } from 'react';
import { t } from '@base/utils/helpers';

function CreateTopic() {
  const history = useHistory();
  const { url } = useRouteMatch();
  const forumService: IForumService = container.resolve('forumService');
  const message: IMessage = container.resolve('message');
  const [loading, setLoading] = useState(false);

  const submitCreate = (data: FormData) => {
    const threadsName = url.split('/')[2];
    setLoading(true);
    forumService
      .createTopic(forumId[threadsName], data.subject, data.message)
      .then((res) => {
        if (res.code === ResponseCode.SUCCESS) {
          //@ts-ignore
          message.success(res.thread_id ? `Thread ${res.thread_id} created` : res.message, () =>
            history.goBack()
          );
        } else {
          message.warning(res.message!);
        }
      })
      .catch((e) => {
        message.error(e.message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <div className={styles.createHeader}>
        <button className={styles.btn} onClick={() => history.goBack()}>
          <UndoIcon height={17} width={17} />
        </button>
        <p>Create new topic</p>
      </div>
      <div className={styles.createBody}>
        <FormWithEditor
          titleForm={t("create_new_topic")}
          placeholderInput={t("topic")}
          buttonTitle={t('create')}
          placeholderEditor={t("your_message")}
          submit={submitCreate}
          requiredInput={true}
          loading={loading}
        />
      </div>
    </>
  );
}

export default CreateTopic;
